import { AlertBar2 } from "@/components/UI2/atoms/AlertBar";
import dayjs from "@/lib/helpers/dayjs";
import { Heading2 } from "@/ui2/atoms/Heading";
import type { UUID } from "@/core/types";

import { useNoteAddendumCosignDetails } from "../../api/queries/useNoteAddendumCosignDetails";

import { AddendumRejectionBannerSkeleton } from "./AddendumRejectionBannerSkeleton";

type Props = {
  addendumId: UUID;
};

export function AddendumRejectionBanner({ addendumId }: Props) {
  const { data, isLoading } = useNoteAddendumCosignDetails({ addendumId });

  if (isLoading) return <AddendumRejectionBannerSkeleton />;
  if (!data) return null;

  return (
    <AlertBar2 className="tw:flex tw:flex-col tw:gap-3.5" variant="warning">
      <Heading2 className="tw:text-inherit" size={2}>
        Addendum returned
      </Heading2>

      <dl className="tw:grid tw:grid-cols-[auto_1fr] tw:gap-x-6 tw:gap-y-2">
        <dt className="tw:font-semibold">Reviewed By:</dt>
        <dd>
          {data.reviewing_supervisor_name ?? "—"} •{" "}
          {data.rejection_date ? dayjs(data.rejection_date).format("M/D/YYYY, h:mm A") : "—"}
        </dd>

        <dt className="tw:font-semibold">Reasoning:</dt>
        <dd>{data.rejection_reason ?? "—"}</dd>
      </dl>
    </AlertBar2>
  );
}
